module.exports = __webpack_public_path__ + "static/media/b1_p12_clickable.c8d10e8a.mp3";